// @flow

const root = '/setup-assistant'

export default {
  index: root,
  yourProgram: `${root}/program`,
  yourLicense: `${root}/license`,
  yourSpace: `${root}/space`,
}
